module.exports = "/_next/static/files/5a06f77e2f1060d54fb095ced900d979.svg";